import { defineComponent as _defineComponent } from 'vue'
import ProfileAvatar from "@/components/profile/ProfileAvatar.vue";
import TMenuSection from "@/components/lib/menu/TMenuSection.vue";
import ChatMenu from "@/components/menu/ChatMenu.vue";
import keycloakPlugin from "../tmp/keycloak.plugin";
import Menu from "@/components/menu/Menu.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return { __sfc: true,Menu }
}

})